"use strict";
/**
 * AlignmentHeader
 *
 * Sticky header for the Use Case Alignment view: renders the Strategy
 * dropdown (and an optional disabled Use Case dropdown when no useCaseId
 * was supplied by the host) plus the descriptive copy.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignmentHeader = void 0;
var react_1 = __importStar(require("react"));
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var Text_1 = require("office-ui-fabric-react/lib/Text");
var use_case_alignment_constants_1 = require("../utils/use-case-alignment-constants");
var AlignmentHeaderComponent = function (_a) {
    var strategyOptions = _a.strategyOptions, selectedStrategyId = _a.selectedStrategyId, selectedUseCaseId = _a.selectedUseCaseId, isLoadingStrategies = _a.isLoadingStrategies, isLoadingAlignment = _a.isLoadingAlignment, hasStrategies = _a.hasStrategies, showUseCaseDropdown = _a.showUseCaseDropdown, onStrategyChange = _a.onStrategyChange;
    var strategyPlaceholder = !isLoadingStrategies && !hasStrategies
        ? "No strategies available"
        : "Missing strategy selection...";
    var strategyTitleStyle = !selectedStrategyId && selectedUseCaseId
        ? { borderColor: use_case_alignment_constants_1.ALIGNMENT_ERROR_BORDER_COLOR }
        : {};
    var useCaseTitleStyle = !selectedUseCaseId && selectedStrategyId
        ? { borderColor: use_case_alignment_constants_1.ALIGNMENT_ERROR_BORDER_COLOR }
        : {};
    var handleStrategyChange = react_1.useCallback(function (_event, option) {
        if (!option) {
            console.log("[WsUseCaseAlignment] Strategy dropdown change ignored because option is undefined", {
                selectedStrategyId: selectedStrategyId,
            });
            return;
        }
        console.log("[WsUseCaseAlignment] Strategy option clicked", {
            optionKey: String(option.key),
            optionText: option.text,
            optionData: option.data,
        });
        onStrategyChange(String(option.key), option);
    }, [onStrategyChange, selectedStrategyId]);
    return (react_1.default.createElement("div", { className: "ws-tab-header" },
        react_1.default.createElement("div", { className: "ws-header-row" },
            react_1.default.createElement("div", { className: "ws-header-left" },
                react_1.default.createElement("div", { className: "ws-dropdowns-horizontal" },
                    react_1.default.createElement(Dropdown_1.Dropdown, { label: "Select Strategy", placeholder: strategyPlaceholder, options: strategyOptions, selectedKey: selectedStrategyId || undefined, onChange: handleStrategyChange, disabled: isLoadingStrategies || !hasStrategies, required: true, styles: {
                            root: { width: use_case_alignment_constants_1.ALIGNMENT_DROPDOWN_WIDTH },
                            title: strategyTitleStyle,
                        } }),
                    showUseCaseDropdown && (react_1.default.createElement(Dropdown_1.Dropdown, { label: "Select Use Case", placeholder: "Use case is required for this view", options: [], selectedKey: selectedUseCaseId, disabled: true, required: true, styles: {
                            root: { width: use_case_alignment_constants_1.ALIGNMENT_DROPDOWN_WIDTH },
                            title: useCaseTitleStyle,
                        } })))),
            react_1.default.createElement("div", { className: "ws-header-right" },
                react_1.default.createElement(Text_1.Text, { variant: "medium", className: "ws-page-description" }, "Visualize how a strategy connects through business metrics to a specific AI use case. The alignment graph will automatically generate when both selections are made.")))));
};
var AlignmentHeader = react_1.default.memo(AlignmentHeaderComponent);
exports.AlignmentHeader = AlignmentHeader;
AlignmentHeader.displayName = "AlignmentHeader";
